import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useAddressConfig = () => {
    const { t } = useTranslation();

    return useMemo(() => [
        {
            name: t("country"),
            key: "country",
        },
        {
            name: t("address1"),
            key: "address",
        },
        {
            name: t("address2"),
            key: "address2",
        },
        {
            name: t("city"),
            key: "city",
        },
        {
            name: t("state-or-province"),
            key: "stateOrProvince",
        },
        {
            name: t("postal-code"),
            key: "zip",
        },
    ], [t]);
}
